<app-review-section
  [title]="'facilities-data.meter-installation-title' | translate"
  [tooltip]="'tooltips.facilities-data.meter-installation' | translate"
  [sectionId]="sectionIdentifier.TechnicalData_MeterInstallation"
  [applicationId]="applicationId"
  [isDetailsView]="isDetailsView"
  [showButtonsPredicate]="hideButtonsForEmployeeWhenHasChimneySweeper">
  <span class="component-container base-data-container">
    <form [formGroup]="meterInstallationFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
      <div class="form-background">
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-radioButton
              formControlName="meterInstallation"
              id="has-gas-meter-installation"
              label="{{ 'technical-data.has-gas-meter-installation' | translate }}"
              class="p-field-radio"
              name="construction_chimney"
              value="1"></p-radioButton>
          </div>
        </div>
        <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-radioButton
              formControlName="meterInstallation"
              id="no-gas-meter-installation"
              label="{{ 'technical-data.no-gas-meter-installation' | translate }}"
              class="p-field-radio"
              name="construction_chimney"
              value="0"></p-radioButton>
          </div>
        </div>
      </div>
    </form>
  </span>
</app-review-section>
